import React, { useState, useEffect, useRef, Component } from 'react';
import Link from 'next/link'
import Image from 'next/image'
import { useSession } from 'next-auth/react'
import { signIn } from "next-auth/react"
import { KTGet } from '@/kyna/lib/db';

import { useFormik } from 'formik';
import KNModal from "@/kyna/ui/modal/KNModal";

import ForgotPasswordSchema from '@/kyna/lib/validations/ForgotPasswordSchema';

import InputForm from '../../forms/InputForm';
import { useRouter } from 'next/router';

import toast, { Toaster, ToastBar } from "react-hot-toast";
import { KNThemeSuccess, KNThemeError } from "@/kyna/ui/toaster/KNTheme";
import KNToaster from "@/kyna/ui/toaster/KNToaster";
// import bcrypt from 'bcryptjs'

import youtube from '../../../public/assets/img/youtube.png';
import { FiYoutube } from 'react-icons/fi';

const getUsers = async (params) => {

  return await KTGet('/api/users/applicant', {
    limit: 1,
    username: params.username,
  })

}

const ForgotPassword = () => {
  const [isButtonClicked, setButtonClicked] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [loginFormMessage, setLoginFormMessage] = useState(null);
  const [loginFormMessageType, setLoginFormMessageType] = useState(null);
  const { data: session, status } = useSession()
  const router = useRouter()

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [iconType, setIconType] = useState("error");
  const [modalTitle, setModalTitle] = useState("Failed");
  const [error, setError] = useState("");
  const [modalMessage, setModalMessage] = useState("Server Failed");

  const NEXT_PUBLIC_VERCEL_URL = process.env.NEXT_PUBLIC_VERCEL_URL

  const submitHandler = async (values) => {
    // e.preventDefault()


    // console.log("values", values)
    // return;

    setLoading(true)
    setLoginFormMessage(null)
    setLoginFormMessageType(null)

    console.log("Submit")

    const formDataRes = await getUsers({
      username: values.username
    })
    const result = formDataRes?.data?.result
    console.log("formDataRes username:", formDataRes?.data?.result)

    setLoading(false)
    if (values.username == "") {
      setLoginFormMessage("The username field is required.")
      setLoginFormMessageType("text-red-400")
      return
    }
    if (result == null) {
      setLoginFormMessage("Invalid email. Please try again.")
      setLoginFormMessageType("text-red-400")
      return
    } else {
      
      const res = await fetch("/api/sendgrid", {
        body: JSON.stringify({
          email: values.username,
          subject: "Forgot Password",
          // message: message.props.initialValue[0].children[0].text,
          html:
            `
            <!doctype html>
            <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
            
            <head>
              <title>Forgot Password</title>
              <meta http-equiv="X-UA-Compatible" content="IE=edge">
              <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1">
              <style type="text/css">
                #outlook a {
                  padding: 0;
                }
                body {
                  margin: 0;
                  padding: 0;
                  -webkit-text-size-adjust: 100%;
                  -ms-text-size-adjust: 100%;
                }
                table,
                td {
                  border-collapse: collapse;
                  mso-table-lspace: 0pt;
                  mso-table-rspace: 0pt;
                }
                img {
                  border: 0;
                  height: auto;
                  line-height: 100%;
                  outline: none;
                  text-decoration: none;
                  -ms-interpolation-mode: bicubic;
                }
                p {
                  display: block;
                  margin: 13px 0;
                }
              </style>
            
              <link rel="preconnect" href="https://fonts.googleapis.com">
              <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
              <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;700&display=swap" rel="stylesheet">
            
              <style type="text/css">
                @import url(https://fonts.googleapis.com/css?family=Roboto:400,700);
              </style>
            
              <style type="text/css">
                @media only screen and (min-width:480px) {
                  .mj-column-per-100 {
                    width: 100% !important;
                    max-width: 100%;
                  }
                  .mj-column-per-35 {
                    width: 35% !important;
                    max-width: 35%;
                  }
                  .mj-column-per-65 {
                    width: 65% !important;
                    max-width: 65%;
                  }
                }
              </style>
              <style media="screen and (min-width:480px)">
                .moz-text-html .mj-column-per-100 {
                  width: 100% !important;
                  max-width: 100%;
                }
                .moz-text-html .mj-column-per-35 {
                  width: 35% !important;
                  max-width: 35%;
                }
                .moz-text-html .mj-column-per-65 {
                  width: 65% !important;
                  max-width: 65%;
                }
              </style>
              <style type="text/css">
                @media only screen and (max-width:480px) {
                  table.mj-full-width-mobile {
                    width: 100% !important;
                  }
                  td.mj-full-width-mobile {
                    width: auto !important;
                  }
            
                  .site-logo,
                  .site-name {
                    display: block;
                    width: 100%;
                  }
                  .site-logo {
                    padding-bottom: 15px;
                  }
                  .site-name > div {
                    padding-left: 0 !important;
                  }
            
                }
              </style>
            </head>
            
            <body style="word-spacing: normal; background-color: #f1f1f1;">
              <div style="background-color: #f1f1f1; padding-left: 20px; padding-right: 20px; padding-top: 20px;">
                <div style="margin: 30px auto; background-color: #ffffff; max-width: 600px;">
                  <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width: 100%; background: #193e8c;">
                    <tbody>
                      <tr>
                        <td style="direction: ltr; text-align: center;">
                          <div class="mj-column-per-100 mj-outlook-group-fix" style="text-align: left; direction: ltr; display: inline-block; vertical-align: middle; width:100%;">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: middle;" width="100%">
                              <tbody>
                                <tr>
                                  <td align="" style="padding: 20px 25px; word-break: break-word;">
                                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse: collapse; border-spacing: 0px; margin: auto;">
                                      <tbody>
                                        <tr>
                                          <td class="site-logo" style="">
                                            <img alt="PMHA" height="auto" src="https://ucarecdn.com/b68fe996-fcc1-479c-ad51-778f8f283205/pmhawhitebgapplogo.png" style="border: 0; display: block; outline: none; text-decoration: none; height: auto; width: 100%; max-width: 80px; margin: auto;" />
                                          </td>
                                          <td class="site-name" style="">
                                            <div style="font-family: 'Inter', sans-serif; font-size: 18px; font-weight: 700; line-height: 26px; text-align: center; text-transform: uppercase; letter-spacing: 2px; color: #ffffff; padding-left: 20px; max-width: 300px; margin: auto;">Philippine Mental Health Association Inc.</div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width: 100%;">
                    <tbody>
                      <tr>
                        <td style="direction: ltr; padding: 0; text-align: center;">
                          <div class="mj-column-per-100 mj-outlook-group-fix" style="text-align: left; direction: ltr; display: inline-block; vertical-align: middle; width: 100%;">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: middle;" width="100%">
                              <tbody>
                                <tr>
                                  <td align="center" style="padding: 30px 25px 0; word-break: break-word;">
                                    <div style="font-family: 'Inter', sans-serif; font-size: 20px; font-weight: 700; line-height: 28px; text-align: center; text-transform: uppercase; letter-spacing: 2px; color: #193e8c;">Forgot Password</div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%; max-width: 550px;">
                              <tbody>
                                <tr>
                                  <td style="direction:ltr; font-size: 0px; padding: 30px 20px 20px;text-align:center;">
                                    <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
                                      <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                                        <tbody>
                                          <tr>
                                            <td align="center" style="font-size: 0px; padding: 10px 0; word-break: break-word;">
                                              <div style="font-family: 'Inter', sans-serif; font-size: 16px; font-weight: 400; line-height: 1; text-align: left; color: #000000;">Hi, <strong>${formDataRes?.data?.result?.person?.first_name}!</strong></div>
                                              <div style="font-family: 'Inter', sans-serif; font-size: 14px; line-height: 22px; text-align: left; color: #000000; padding-top: 10px;">I heard that you need a password reset. Please click the button below and you will be redirected to a page from which you can set a new password.</div>
                                              <div style="font-family: 'Inter', sans-serif; font-size: 14px; line-height: 22px; text-align: center; color: #000000; padding-top: 35px; padding-bottom: 20px;">
                                                <a href='${NEXT_PUBLIC_VERCEL_URL}/account/post/${values.username}/' target="_blank" style="font-family: 'Inter', sans-serif; font-size: 14px; font-weight: 600; padding: 15px 25px; color: #ffffff; background: #2eafcf; border-radius: 100px; text-decoration: none; text-transform: uppercase; letter-spacing: 2px;">Reset Password</a>
                                              </div>
                                              <div style="font-family: 'Roboto', sans-serif; font-size: 12px; line-height: 20px; text-align: center; color: #000000; padding-top: 5px; padding-bottom: 20px;">If the button above is not working, please <a href="${NEXT_PUBLIC_VERCEL_URL}/account/post/${values.username}/" target="_blank" style="text-decoration: underline; color: #2eafcf;">click here</a> to reset your password.</div>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td align="center" style="font-size: 0px; padding: 10px 0 60px; word-break: break-word;">
                                              <div style="font-family: 'Inter', sans-serif; font-size: 14px; font-weight: 400; line-height: 1; text-align: left; color: #000000;">Thank you,</div>
                                              <div style="font-family: 'Inter', sans-serif; font-size: 14px; font-weight: 600; line-height: 22px; text-align: left; color: #000000;">PMHA Team</div>
                                            </td>
                                          </tr>
            
            
                                          <!-- EMAIL NOTIFICATION FOOTER -->
                                          <tr>
                                            <td align="center" style="font-size: 0px; padding-top: 15px; word-break: break-word; border-top: 1px solid #eee;">
                                              <div style="font-family: 'Inter', sans-serif; font-size: 14px; font-weight: 600; line-height: 22px; text-align: left; color: #000000;">
                                                <ul style="list-style: none; padding-left: 0; text-align: center; margin-top: 0; margin-bottom: 5px;">
                                                  <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                    <a href="https://www.facebook.com/PMHAofficial" target="_blank">
                                                      <img style="width: 14px;" src="https://ucarecdn.com/0869ab43-f54d-4f83-8781-8fed79d7938b/" alt="Facebook">
                                                    </a>
                                                  </li>
                                                  <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                    <a href="https://twitter.com/PMHAofficial" target="_blank">
                                                      <img style="width: 14px;" src="https://ucarecdn.com/f8e6e9fd-7f11-4515-b088-e5567a9915ba/" alt="Twitter">
                                                    </a>
                                                  </li>
                                                  <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                    <a href="https://www.instagram.com/pmhaofficial/" target="_blank">
                                                      <img style="width: 14px;" src="https://ucarecdn.com/6b306f1a-796f-404f-86ba-400a0f766e83/" alt="Instagram">
                                                    </a>
                                                  </li>
                                                  <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                    <a href="https://www.youtube.com/channel/UCvZjwCE8FucFXNrcGjgPz_w" target="_blank">
                                                      <img style="width: 14px;" src="https://ucarecdn.com/a822e322-e351-4d21-8bf7-14ac85a19f28/" alt="Youtube">
                                                    </a>
                                                  </li>
                                                  <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                    <a href="https://www.tiktok.com/@pmhaofficial" target="_blank">
                                                      <img style="width: 14px;" src="https://ucarecdn.com/2ed79507-7d8e-499c-afe6-85b2988aeea9/" alt="TikTok">
                                                    </a>
                                                  </li>
                                                </ul>
                                              </div>
                                              <div style="font-family: 'Inter', sans-serif; font-size: 12px; font-weight: 400; line-height: 22px; text-align: center; color: #000000; letter-spacing: 2px;">PMHA © ${new Date().getFullYear()}</div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </body>
            
            </html>
            `
        }),
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
      });
      const { error } = await res.json();
      if (error) {
        console.log(error);
        return;
      }
      // toast.dismiss();
      // toast.success("Request has been sent to your email!\r\n To Reset your password, follow the instruction that has been sent to " + values.username, {
      //   ...KNThemeSuccess, position: 'top-center', duration: 8000,
      //   position: "top-center",
      // });

      setIconType("info");
      setModalTitle("Success!");
      setModalMessage(
        "An email has been sent to your email address, " + values.username + ". Follow the instructions in the email to reset your password."
      );
      setLoading(false);
      setIsOpenModal(true);
      // router.push('/')
    }
    // if (result.error) {
    //     console.log("error loginForm HERE FROM SERVER")
    //     console.log(result.error)
    //     // alert("error");
    // } else {
    //     console.log("result", result)

    //     if (result.ok) {
    //         // window.location = '/app/account/onboarding'
    //         router.push('/account/login')
    //     }

    // }

  }





  const formik = useFormik({
    initialValues: {
      username: '',
    },
    validationSchema: ForgotPasswordSchema,
    onSubmit: values => {
      //   alert(JSON.stringify(values, null, 2));
      submitHandler(values)
    },
  });

  const testBtnClick = () => {
    // alert("Button Clicked!")
    setButtonClicked(!isButtonClicked)
  };


  return (
    <>
      <form
        onSubmit={formik.handleSubmit}
        autoComplete={"off"}
      >
        <InputForm
          type="text"
          id="username"
          name="username"
          placeholder="Enter your email address"
          withFormik={true}
          formik={formik}
        />

        {
          loginFormMessage != '' ? (
            <div className={`mt-1 mb-2 ${loginFormMessageType}`}>
              {loginFormMessage}
            </div>
          ) : null
        }

        <div className="grid sm:grid-cols-3 grid-cols-1 gap-y-2 sm:gap-x-3 gap-x-0 items-center">
          <div className="col-span-2">
            <div className="form-group">
              <Link href="/account/login">
                <a className='text-black hover:text-light-blue flex items-center'>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" class="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18" />
                  </svg>
                  <span className="mb-0 ml-2">Back to Login</span>
                </a>
              </Link>
            </div>
          </div>
          <div className="col-span-1"> 
            <div className="form-group text-right">
              <button type="submit" disabled={isLoading ? true : false} className="btn-secondary rounded-full max-w-[120px] mx-auto w-full text-center">
                {
                  !isLoading ? 'Submit' : (
                    <>
                      <span className='relative text-center'>
                        <svg className="animate-spin h-5 w-5 text-white mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                      </span>
                    </>
                  )
                }
              </button>
            </div>
          </div>
        </div>
      </form>

      <KNModal
        title={modalTitle}
        iconType={iconType}
        isOpen={isOpenModal}
        noFooter={true}
        bodyClass={"!max-w-3xl mt-10"}
        closeModal={() => {
          setIsOpenModal(false);
        }}
        body={
          <ForgotPasswordModal
            modalMessage={modalMessage}
            setIsOpenModal={setIsOpenModal}
            iconType={iconType}
          />
        }
      />

    </>

  );
};

const ForgotPasswordModal = ({ modalMessage, setIsOpenModal, iconType }) => {
  return (
    <div>
      <p className="sm:text-lg text-base">{modalMessage}</p>
      <div className="flex items-center justify-end gap-2 mt-8">
        {iconType === "info" ? (
          <button
            className="btn btn-close rounded-full"
            onClick={() => {
              setIsOpenModal(false);
              window.location.reload();
            }}
          >
            Close
          </button>
        ) : (
          <button
            className="btn btn-primary rounded-full"
            onClick={() => {
              setIsOpenModal(false);
              router.push('/')
            }}
          >
            Okay
          </button>
        )}
      </div>
    </div>
  );
};


export default ForgotPassword;
